export const MmCollapsedLogoIcon = () => (
  <svg
    width="29"
    height="32"
    viewBox="0 0 29 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1273_6040)">
      <path
        d="M19.8908 6.88954C18.1218 2.95768 15.7515 2.37036 14.4995 2.37036C13.7855 2.37036 12.7059 2.56027 11.584 3.45707C11.6297 3.48169 11.6754 3.50631 11.7211 3.53093C12.7832 4.1288 14.8547 5.09594 16.6483 8.34904C17.6998 10.2552 18.055 13.1214 18.055 15.9982H21.6106C21.6106 12.5869 20.9986 9.35135 19.8908 6.88954Z"
        fill="#3AA7EA"
      />
      <path
        d="M7.38845 5.9259C3.40032 5.9259 0.277344 10.3501 0.277344 15.9982C0.277344 20.8163 2.54924 24.7412 5.68981 25.7927C4.48352 22.9476 3.8329 19.5503 3.8329 15.9982C3.8329 12.1578 5.70739 9.48146 7.38845 9.48146C9.06952 9.48146 10.944 12.1578 10.944 15.9982H14.4996C14.4996 10.3501 11.3766 5.9259 7.38845 5.9259Z"
        fill="#3AA7EA"
      />
      <path
        d="M13.736 29.3658C11.9706 25.8349 10.9823 21.1996 10.9472 16.2866C10.9472 16.1916 10.9472 16.0967 10.9472 16.0017H7.3916C7.3916 19.4131 8.00354 22.6486 9.11135 25.1104C10.606 28.4338 12.5297 29.3693 13.8486 29.5768C13.8134 29.5065 13.7747 29.4362 13.7396 29.3658H13.736Z"
        fill="#3AA7EA"
      />
      <path
        d="M27.0482 5.31748C26.482 3.80523 25.7997 2.59543 25.019 1.71269C23.7599 0.295394 22.4727 -0.00354004 21.6111 -0.00354004C21.0273 -0.00354004 20.2395 0.133618 19.4025 0.671699C20.3943 1.48058 22.5571 3.49223 23.7177 6.56597C24.6567 9.05592 25.1667 12.4075 25.1667 15.9982C25.1667 19.5889 24.6532 22.9405 23.7177 25.4305C22.7963 27.8888 21.8643 28.4409 21.6111 28.4409C21.3579 28.4409 20.4259 27.8888 19.5045 25.4305C18.569 22.9405 18.0556 19.5889 18.0556 15.9982H14.5C14.5 20.0039 15.0944 23.7986 16.174 26.679C16.7402 28.1912 17.4225 29.401 18.2033 30.2837C19.4623 31.701 20.7495 32 21.6111 32C22.4727 32 23.7599 31.701 25.019 30.2837C25.7997 29.4045 26.482 28.1912 27.0482 26.679C28.1279 23.7986 28.7222 20.0039 28.7222 15.9982C28.7222 11.9925 28.1279 8.1978 27.0482 5.31748Z"
        fill="#3AA7EA"
      />
    </g>
    <defs>
      <clipPath id="clip0_1273_6040">
        <rect
          width="28.4444"
          height="32"
          fill="white"
          transform="translate(0.277344)"
        />
      </clipPath>
    </defs>
  </svg>
);
